import { render, staticRenderFns } from "./PageSettingsBackgroundImageSettings.vue?vue&type=template&id=8bdb6846"
import script from "./PageSettingsBackgroundImageSettings.vue?vue&type=script&lang=ts"
export * from "./PageSettingsBackgroundImageSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports